angular.module('impactx.approval').controller('CateringDialogViewCtrl', CateringDialogViewCtrl);

CateringDialogViewCtrl.$inject = ['$scope', 'dataGen', '$mdDialog', 'atiId'];

function CateringDialogViewCtrl($scope, dataGen, $mdDialog, atiId) {
    var ctrl = this;

    ctrl.participantsEntryPoint = '/approval/cateringparticipants';

    ctrl.getData = function () {
        var paramObj = {
            atiId: atiId
        };
        dataGen.getData($scope, paramObj, '/approval/viewcatering');
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

    ctrl.getData();
}